import Delete20 from '@carbon/icons-react/es/delete/20';
import styled from 'styled-components';

export const Wrapper = styled.div<{ isFullScreen: boolean }>`
  width: ${(props) => (props.isFullScreen ? '100%' : '660px')};
`;

export const StatusEditorWrapper = styled.div`
  display: flex;
  height: 100%;
  flex-flow: column;
`;

export const EditorHeadWrapper = styled.div`
  flex: 0 1 auto;
`;

export const EditorContentWrapper = styled.div`
  flex: 1 1 auto;
  overflow-y: scroll;
`;

export const EditorAttachementsWraper = styled.div`
  flex: 0 1 auto;
`;

export const EditorFooterContentWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: var(--spacing-03) var(--spacing-05);
  border-top: 1px solid var(--border-color);
`;

export const EditorFooterWrapper = styled.div`
  flex: 0 1 auto;
`;

export const ExtraToolsWrapper = styled.div`
  display: flex;
  align-items: flex-start;
`;

export const ToolsWrapper = styled.div`
  width: 100%;

  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const DeleteIcon = styled(Delete20)`
  color: var(--gray-100);

  &:hover {
    color: var(--red-60);
  }
`;

export const OutsideEmails = styled.div`
  padding: var(--spacing-03) var(--spacing-06);
  background: var(--private-01);
  color: var(--gray-80);
  font-size: var(--font-size-sm);
`;
export const MarginSpacer = styled.div`
  margin-top: var(--spacing-06);
`;
